import {cva} from 'class-variance-authority';

export const paperVariants = cva('rounded-soft p-4', {
  variants: {
    variant: {
      white: 'bg-white',
      neutral: 'bg-neutral-light',
    },
    shadow: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      variant: 'white',
      shadow: true,
      class: 'shadow-rounded',
    },
    {
      variant: 'white',
      shadow: false,
      class: 'border border-neutral-200/70',
    },
  ],
  defaultVariants: {
    variant: 'neutral',
    shadow: true,
  },
});
